var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"}},[_c('path',{attrs:{"d":"M11.1624 6.94358L0.770043 12.9436L0.770043 0.943573L11.1624 6.94358Z","fill":"#A2B1C6"}})])}
var staticRenderFns = []

export { render, staticRenderFns }